import StripeElement from "legacy/credit-cards/StripeElement"
import PropTypes from "prop-types"
import React from "react"

import Modal from "src/components/Modal"

class CreditCardModal extends React.Component {
  constructor(args) {
    super(args)
    this.state = {
      showModal: false,
      errorMessage: null,
      processing: false,
    }
    this.openModal = this.openModal.bind(this)
    this.closeModal = this.closeModal.bind(this)
    this.save = this.save.bind(this)
    this.handleFailure = this.handleFailure.bind(this)
    this.handleSuccess = this.handleSuccess.bind(this)
    this.stripeElement = null
    this.setStripeElementRef = (element) => {
      this.stripeElement = element
    }
  }

  openModal() {
    this.setState({ showModal: true })
  }

  closeModal() {
    this.setState({ showModal: false, errorMessage: null })
  }

  save() {
    this.setState({ processing: true })
    this.stripeElement.createStripePaymentMethod()
  }

  handleFailure(response = null) {
    this.setState({
      processing: false,
      errorMessage: response,
    })
  }

  handleSuccess(response) {
    $.post(this.props.endpoint, { stripeToken: response.id }, () => {
      if (this.props.customCallback) {
        this.closeModal()
        this.props.customCallback(response)
      } else {
        location.reload()
      }
    })
      .fail((data) => {
        let error = "Failed to save card."
        if (data.responseText && JSON.parse(data.responseText).error) {
          error = JSON.parse(data.responseText).error
        }
        this.handleFailure(error)
      })
      .always(() => {
        this.setState({ processing: false })
      })
  }

  renderModal() {
    return (
      <Modal
        isOpen={this.state.showModal}
        onClose={this.closeModal}
        size="mediumFixed"
      >
        <Modal.Header title="Add Payment Method" />
        <Modal.Body>
          <StripeElement
            ref={this.setStripeElementRef}
            successCallback={this.handleSuccess}
            errorCallback={this.handleFailure}
          />
          {this.state.errorMessage && (
            <div className="alert alert-danger">{this.state.errorMessage}</div>
          )}
        </Modal.Body>
        <Modal.Footer
          cancelBtnText="Cancel"
          confirmBtnText="Add Card"
          confirmBtnLoading={this.state.processing}
          onClose={this.closeModal}
          onSubmit={this.save}
        />
      </Modal>
    )
  }

  render() {
    return (
      <div>
        <button
          type="button"
          className={"btn btn-primary"}
          onClick={this.openModal}
        >
          Add New Card
        </button>
        {this.renderModal()}
      </div>
    )
  }
}

CreditCardModal.propTypes = {
  customCallback: PropTypes.func,
  endpoint: PropTypes.string.isRequired,
}

export default CreditCardModal
